import { render, staticRenderFns } from "./GenericTextarea.vue?vue&type=template&id=39b2ca20"
import script from "./GenericTextarea.vue?vue&type=script&lang=js"
export * from "./GenericTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports